export default {"src":"/_next/static/media/no_offer.00a072ae.svg","height":188,"width":300,"blurWidth":0,"blurHeight":0};